export default __webpack_public_path__ + "static/media/backgroundAbout.a8a2ad1d.png";